import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetBudgetedSummary = async (bundleID, requestID,workReqID,navigate) => {
  if (workReqID == null) {
    // you can also console.warn here if you like
    return [];
  }
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        bundleID,
        requestID,
        workReqID
        }).toString();
      const response = await fetch(`${dev_baseUrl}/Job/getBudgetedSummary?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();   
      // console.log(data)     

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else if(response.ok && !data.isError ){
        return data.result;
      } 
      else {
        console.error('Server error:', data);
        return { isError:true, message: 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
